var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46878 20.031C8.39905 19.9614 8.34373 19.8787 8.30599 19.7876C8.26825 19.6966 8.24882 19.599 8.24882 19.5004C8.24882 19.4019 8.26825 19.3043 8.30599 19.2132C8.34373 19.1222 8.39905 19.0394 8.46878 18.9698L15.4391 12.0004L8.46878 5.03104C8.32805 4.89031 8.24899 4.69944 8.24899 4.50042C8.24899 4.30139 8.32805 4.11052 8.46878 3.96979C8.60952 3.82906 8.80039 3.75 8.99941 3.75C9.19843 3.75 9.3893 3.82906 9.53004 3.96979L17.03 11.4698C17.0998 11.5394 17.1551 11.6222 17.1928 11.7132C17.2306 11.8043 17.25 11.9019 17.25 12.0004C17.25 12.099 17.2306 12.1966 17.1928 12.2876C17.1551 12.3787 17.0998 12.4614 17.03 12.531L9.53004 20.031C9.46038 20.1008 9.37766 20.1561 9.28662 20.1938C9.19557 20.2316 9.09797 20.251 8.99941 20.251C8.90085 20.251 8.80325 20.2316 8.7122 20.1938C8.62116 20.1561 8.53844 20.1008 8.46878 20.031Z",
    fill: "#F2F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right-arrow.b4966c731e11f08bec89b8739c1e5b3b.svg";
export { ForwardRef as ReactComponent };